import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import PropTypes from "prop-types"
import { FeatureKey, FeaturePermission } from "../../api/generated"
import { featureKeyPropType, permissionInContextPropType } from "../propTypes"
import { getFeatureInfo, getFeaturePermissionInfo } from "../utils"
import FeatureBlockUI from "./FeatureBlockUI"

const FeatureBlock = ({
  featureKey,
  featurePermission,
  to
}: {
  to: string | object | null
  featureKey: FeatureKey
  featurePermission: FeaturePermission
}) => {
  const { t } = useTranslate()
  const featureInfo = getFeatureInfo(featureKey, t)
  const featurePermissionInfo = getFeaturePermissionInfo(
    featureKey,
    featurePermission,
    t
  )

  return (
    <FeatureBlockUI
      featureInfo={featureInfo}
      featurePermissionInfo={featurePermissionInfo}
      to={to}
    />
  )
}

FeatureBlock.displayName = "FeatureBlock"

FeatureBlock.propTypes = {
  featureKey: featureKeyPropType.isRequired,
  featurePermission: permissionInContextPropType.isRequired,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
}

FeatureBlock.defaultProps = {
  featureKey: null,
  featurePermission: null,
  to: null
}

export default FeatureBlock
